<div class="modal-header"
[class.modal-header--skybid]="isSkybidV6enabled">
  @if (isSkybidV6enabled) {
    <button
      id="btnClose"
      type="button"
      class="btn-close close btn-close--skybid"
      aria-label="Close"
      (click)="cancel()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  }
  <div class="row">
    <div class="col">
      <h4 class="main-title text-start mb-0">
        {{ appCopy.smsTripsTitle }}
      </h4>
    </div>
  </div>
</div>
<div class="modal-body" [formGroup]="form"
     [class.modal-body--skybid]="isSkybidV6enabled">
  <div class="row mb-3">
    <div
      class="col"
      [innerHTML]="(isSkybidV6enabled ? skybidV6Copy.beforeWeContinue : appCopy.smsTripsBody) | safeHtml: SanitizerValueType.HTML"
    ></div>
  </div>
  <div class="row flight-info-journey start-rule">
    <div class="col col-12">
      <div class="row"
      [class.my-3]="!isSkybidV6enabled">
        <div class="col">
          <div
            class="row"
            *ngFor="let contact of validationContactList; index as idx"
          >
            <div class="col d-flex align-items-center">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="validationContact"
                  id="contact-{{ contact.key }}"
                  value="{{ contact.key }}"
                  data-qa="validation-radio"
                  formControlName="validationContact"
                />
                <label class="form-check-label" for="contact-{{ contact.key }}">
                  {{ contact.phoneNumber | hide: (isSkybidV6enabled ? 'phone' : undefined)}}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer" *ngIf="form.valid"
     [class.modal-footer--skybid]="isSkybidV6enabled">
  <button
    class="btn btn-outline-primary"
    (click)="cancel()"
    data-qa="tripCheckIn-cancel-button"
  >
    {{ tripDetailsCopy.cancelCopy }}
  </button>
  <button
    class="btn btn-primary"
    (click)="submit()"
    data-qa="tripCheckIn-submit-button"
  >
    {{ isSkybidV6enabled ? skybidV6Copy.sendCode : tripDetailsCopy.submitCopy }}
  </button>
</div>
@if (isSkybidV6enabled) {
  <div class="validation-modal__contact">
    <p>{{skybidV6Copy.troubleReceivingTheCode}} <a [href]="skybidV6Copy.supportPageLink" target="_blank">{{skybidV6Copy.contactUsHere}}</a> </p>
  </div>
}
